import React from 'react';

import type { RenderRovoChatRemixPickerProps } from '@atlassian/conversation-assistant/ui/rovo-chat-remix-view';

import { LoadableLazy } from '@confluence/loadable';

const LazyRovoChatRemixPickerAdapter = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceRovoChatRemixPicker" */ './RovoChatRemixPickerAdapter.tsx'
			)
		).RovoChatRemixPickerAdapter,
});

export const renderRovoChatRemixPicker = ({
	isDisabled,
	onSelect,
	preset,
}: RenderRovoChatRemixPickerProps): React.ReactNode => (
	<LazyRovoChatRemixPickerAdapter isDisabled={isDisabled} onSelect={onSelect} preset={preset} />
);
